export function openInNewTab(url: string) {
  window.open(url, '_blank');
}
